const formatGlAccountLabel = (account: { accountNumber: string; name: string } | null | undefined): string => {
	if (!account) return "—";
	return account.accountNumber ? `${account.accountNumber} — ${account.name}` : account.name;
};

export default formatGlAccountLabel;
